"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const map_component_1 = require("../map.component");
class PlayerComponent {
    constructor(mapComp) {
        this.mapComp = mapComp;
    }
    ngOnInit() {
    }
    ngAfterViewInit() {
    }
    ngOnDestroy() {
    }
    setSpeed() {
        if (this.mapComp.playingSpeed == 0.025) {
            this.mapComp.playingSpeed = 0.0075;
        }
        else {
            this.mapComp.playingSpeed += 0.005;
        }
        if (this.mapComp.playingSpeedX == 4) {
            this.mapComp.playingSpeedX = 0.5;
        }
        else if (this.mapComp.playingSpeedX == 2) {
            this.mapComp.playingSpeedX = 4;
        }
        else {
            this.mapComp.playingSpeedX += 0.5;
        }
        console.log(this.mapComp.playingSpeed);
    }
}
exports.PlayerComponent = PlayerComponent;
